import { FormattedMessage } from "react-intl";

export const FooterData = [
  {
    category: <FormattedMessage id="Company" defaultMessage="Company" />,
    links: [
      {
        link: <FormattedMessage id="aboutus" defaultMessage="About Us" />,
        to: "/",
      },
      {
        link: <FormattedMessage id="ourteam" defaultMessage="Our Team" />,
        to: "/",
      },
      {
        link: <FormattedMessage id="careers" defaultMessage="Careers" />,
        to: "/",
      },
      {
        link: (
          <FormattedMessage id="our-partners" defaultMessage="Our Partners" />
        ),
        to: "/",
      },
      {
        link: <FormattedMessage id="academy" defaultMessage="Academy" />,
        to: "/",
      },
    ],
  },
  {
    category: <FormattedMessage id="WhatWeDo" defaultMessage="What we do" />,
    links: [
      {
        link: (
          <FormattedMessage id="our-services" defaultMessage="Our Services" />
        ),
        to: "/",
      },
      {
        link: <FormattedMessage defaultMessage="web-design" id="web-design" />,
        to: "/",
      },
      {
        link: (
          <FormattedMessage id="Game" defaultMessage="Game Design" />
        ),
        to: "/",
      },
      {
        link: <FormattedMessage id="branding" defaultMessage="Branding" />,
        to: "/",
      },
      {
        link: (
          <FormattedMessage id="motion-design" defaultMessage="Motion Design" />
        ),
        to: "/",
      },
    ],
  },
  {
    category: <FormattedMessage id="portfolio" defaultMessage="Portfolio" />,
    links: [
      {
        link: (
          <FormattedMessage
            id="ViewPortfolio"
            defaultMessage="View Portfolio"
          />
        ),
        to: "/",
      },
      {
        link: <FormattedMessage id="insights" defaultMessage="Insights" />,
        to: "/",
      },
      {
        link: <FormattedMessage id="clients" defaultMessage="Clients" />,
        to: "/",
      },
      {
        link: <FormattedMessage id="ideas" defaultMessage="Ideas " />,
        to: "/",
      },
      {
        link: <FormattedMessage id="strategy" defaultMessage="Strategy " />,
        to: "/",
      },
    ],
  },

  {
    category: <FormattedMessage id="support" defaultMessage="Support" />,
    links: [
      {
        link: <FormattedMessage id="contact-us" defaultMessage="Contact Us" />,
        to: "/contact",
      },
      {
        link: <FormattedMessage id="faqs" defaultMessage="FAQs" />,
        to: "/",
      },
      {
        link: (
          <FormattedMessage id="how-we-work" defaultMessage="How We Work" />
        ),
        to: "/",
      },
      {
        link: <FormattedMessage id="newsletter" defaultMessage="Newsletter" />,
        to: "/",
      },
      {
        link: <FormattedMessage id="blog" defaultMessage="Blog" />,
        to: "/Blog",
      },
    ],
  },
];
